import SignOutScreen from "./SignOutScreenContainer";

export default SignOutScreen;
